import React from "react";

const Preloader = () => {
  return (
    <div className="preloader">
      <div className="lds-hourglass"></div>
    </div>
  );
};

export default Preloader;